import { Col, Row } from 'antd';
import cn from 'classnames';
import React, { ReactNode } from 'react';
import KickImage from 'Reuseables/KickImage';
import IScroll, {
  Props as InfiniteScrollBaseProps,
} from 'react-infinite-scroll-component';
import Styles from './InfiniteScroll.module.scss';
import ReactLoading from 'react-loading';

type TFunctionReturnNode = () => ReactNode | ReactNode[];

interface IInfiniteScrollProps
  extends Omit<InfiniteScrollBaseProps, 'loader' | 'children'> {
  renderContent: ReactNode | ReactNode[] | TFunctionReturnNode;
  loader?: ReactNode;
  isLoading?: boolean;
}

const Loader: React.FC<{ isVisible?: boolean }> = ({ isVisible }) => {
  return (
    <Row
      justify="center"
      align="middle"
      style={{ marginTop: 32, display: isVisible ? 'flex' : 'none' }}
    >
      <Col>
        <ReactLoading type={'spin'} height={50} width={50} color={'#159953'} />
      </Col>
    </Row>
  );
};

const InfiniteScroll: React.FC<IInfiniteScrollProps> = ({
  renderContent,
  className,
  isLoading,
  endMessage,
  ...props
}) => {
  const classes = Styles['infinite-scroll'];

  return (
    <div className={Styles['wrapper']}>
      <IScroll
        loader={<Loader isVisible={isLoading} />}
        endMessage={isLoading ? <Loader isVisible={true} /> : endMessage}
        className={cn(classes, className)}
        {...props}
      >
        {renderContent}
      </IScroll>
    </div>
  );
};

export default InfiniteScroll;
